export default "__VITE_ASSET__gu1xr6Da__"